import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTime = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1675_181)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8 16.5C3.58867 16.5 0 12.9113 0 8.5C0 4.08867 3.58867 0.5 8 0.5C12.4113 0.5 16 4.08867 16 8.5C16 12.9113 12.4113 16.5 8 16.5ZM8 1.83333C4.324 1.83333 1.33333 4.824 1.33333 8.5C1.33333 12.176 4.324 15.1667 8 15.1667C11.676 15.1667 14.6667 12.176 14.6667 8.5C14.6667 4.824 11.676 1.83333 8 1.83333ZM9.66667 11.3867C9.986 11.2027 10.0953 10.7947 9.91067 10.476L8.66667 8.32133V4.5C8.66667 4.132 8.36867 3.83333 8 3.83333C7.63133 3.83333 7.33333 4.132 7.33333 4.5V8.5C7.33333 8.61733 7.364 8.732 7.42267 8.83333L8.756 11.1427C8.88 11.3567 9.10333 11.476 9.334 11.476C9.44733 11.476 9.562 11.4473 9.66667 11.3867Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1675_181",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgTime;
